import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
var CLASSNAME = 'Icons-three-right-directed-arrows';
var ID = 'icon-three-right-directed-arrows';
/* eslint-disable max-len */

export var SVGThreeRightDirectedArrows = function SVGThreeRightDirectedArrows() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 30 16"
  }, React.createElement("g", {
    id: "TerritoryRestrictions",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Country-Selected",
    transform: "translate(-768.000000, -806.000000)",
    strokeWidth: "2",
    stroke: "#FFFFFF"
  }, React.createElement("g", {
    id: "Move-Button",
    transform: "translate(400.000000, 781.000000)"
  }, React.createElement("g", {
    id: "Group",
    transform: "translate(369.000000, 26.000000)"
  }, React.createElement("polyline", {
    id: "Line",
    transform: "translate(23.500000, 7.000000) scale(1, -1) rotate(-270.000000) translate(-23.500000, -7.000000) ",
    points: "16.5 10.5 23.5 3.5 30.5 10.5"
  }), React.createElement("polyline", {
    id: "Line",
    strokeOpacity: "0.6",
    transform: "translate(13.500000, 7.000000) scale(1, -1) rotate(-270.000000) translate(-13.500000, -7.000000) ",
    points: "6.5 10.5 13.5 3.5 20.5 10.5"
  }), React.createElement("polyline", {
    id: "Line",
    strokeOpacity: "0.3",
    transform: "translate(3.500000, 7.000000) scale(1, -1) rotate(-270.000000) translate(-3.500000, -7.000000) ",
    points: "-3.5 10.5 3.5 3.5 10.5 10.5"
  }))))));
};
/* eslint-disable max-len */

var ThreeRightDirectedArrows = function ThreeRightDirectedArrows(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGThreeRightDirectedArrows
  });
};

ThreeRightDirectedArrows.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default ThreeRightDirectedArrows;